import { listen, qsa } from "@fluorescent/dom";
import { slideDown, slideUp, slideStop, isVisible } from "slide-anim";

function Accordion(node) {
  const labels = qsa(".accordion__label", node);

  // Make it accessible by keyboard
  labels.forEach(label => {
    label.href = "#";
    const icon = document.createElement("div");
    icon.classList.add("icon");
    icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 24 24"><path d="M7 10L12 15L17 10H7Z" fill="currentColor"/></svg>`;

    label.append(icon);
  });

  const events = [
    listen(labels, "click", e => {
      const { parentNode: group, nextElementSibling: content } =
        e.currentTarget;
      e.preventDefault();
      slideStop(content);

      if (isVisible(content)) {
        slideUp(content);
        group.setAttribute("data-open", false);
      } else {
        slideDown(content);
        group.setAttribute("data-open", true);
      }
    }),
  ];

  // Open accordions open by default
  labels.forEach(label => {
    const { parentNode: group, nextElementSibling: content } = label;
    const { open } = group.dataset;

    if (open === "true") {
      slideDown(content);
      group.setAttribute("data-open", true);
    }
  });

  function destroy() {
    return () => labelClick();
  }

  return { destroy };
}

export default function Accordions(nodes) {
  let accordions = [];
  if (Array.isArray(nodes) && !nodes.length) return;

  if (nodes.length) {
    accordions = nodes.map(Accordion);
  } else {
    accordions.push(Accordion(nodes));
  }

  function unload() {
    accordions.forEach(accordion => accordion.destroy());
  }

  return { unload };
}
